
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/variants/homeowners/bottom-sticky-cta",
      function () {
        return require("private-next-pages/variants/homeowners/bottom-sticky-cta.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/variants/homeowners/bottom-sticky-cta"])
      });
    }
  